import React from 'react'
import { CreditDocument } from '_gql'
import { yupResolver } from '@hookform/resolvers/yup'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'
import { FormDropdown } from '@divvy-web/skylab.form'
import Modal from '@divvy-web/skylab.modal'
import { useForm, useFormState } from '@divvy-web/skylab.react-hook-form'

import { useDocumentTypes } from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/DocumentsTabContent/useDocumentTypes'

import { type DocumentTypeValidationSchema, documentTypeValidationSchema } from './documentTypeValdiationSchema'
import styles from './styles.module.scss'

export interface SelectDocumentTypeModalProps {
  salesforceCreditId: string
  isShowing: boolean
  onCancel: () => void
  onDocumentTypeConfirmation: (documentType: CreditDocument) => Promise<void>
}

const SelectDocumentTypeModal = ({
  salesforceCreditId,
  isShowing,
  onCancel,
  onDocumentTypeConfirmation,
}: SelectDocumentTypeModalProps) => {
  const [getClassName] = useNameFormatter('SelectDocumentTypeModal')
  const { control, handleSubmit, reset } = useForm<DocumentTypeValidationSchema>({
    resolver: yupResolver(documentTypeValidationSchema),
  })

  const { isValid } = useFormState({ control })

  const { options } = useDocumentTypes({ salesforceCreditId })

  return (
    <Modal
      actions={
        <div className={`${styles[getClassName('actions')]} fs-unmask`}>
          <BasicButton
            type={BASIC_BUTTON_TYPE_OUTLINED}
            onClick={() => {
              reset()
              onCancel()
            }}
          >
            <FormattedMessage
              defaultMessage='Cancel'
              id='sputnik.DocumentUploadTypeModal__47FYwb'
            />
          </BasicButton>
          <BasicButton
            disabled={!isValid}
            onClick={handleSubmit(async ({ documentType }) => {
              await onDocumentTypeConfirmation(documentType)
              reset()
            })}
          >
            <FormattedMessage
              defaultMessage='Submit'
              id='sputnik.DocumentUploadTypeModal__wSZR47'
            />
          </BasicButton>
        </div>
      }
      isShowing={isShowing}
      title={
        <FormattedMessage
          defaultMessage='Select document'
          id='sputnik.DocumentUploadTypeModal__t+2Jv7'
        />
      }
    >
      <div className={`${styles[getClassName('content')]} fs-unmask`}>
        <FormDropdown
          isPortal
          isSearchable
          control={control}
          label={
            <FormattedMessage
              defaultMessage='Document'
              id='sputnik.DocumentUploadTypeModal__wmirkP'
            />
          }
          name='documentType'
          options={options}
        />
      </div>
    </Modal>
  )
}

export default SelectDocumentTypeModal
